import { render, staticRenderFns } from "./ChangesNotification.modal.vue?vue&type=template&id=16300ce2&scoped=true&"
import script from "./ChangesNotification.modal.vue?vue&type=script&lang=ts&"
export * from "./ChangesNotification.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16300ce2",
  null
  
)

export default component.exports